// export const apiPrefix = 'http://172.16.8.102:9003/tenant' // 本地环境
export const apiPrefix = 'https://b.xbyx.cloud/tenant' // 正式环境